Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SocialContentActionsView extends Backbone.View
  template: JST['backbone/templates/monitoring/social_contents_v2/social_content_actions']
  noteTemplate: JST['backbone/templates/monitoring/social_contents_v2/note']

  events:
    'click .notes': 'showNotes'
    'click .moderation-comment': '_showModerationCommentAlert'
    'click .escalate-case': '_escalateCase'
    'click .de-escalate-case': '_deEscalateCase'
    'click .exclude-case': '_excludeCase'
    'click .include-case': '_includeCase'


  initialize: (options = {}) ->
    @model = options.model
    @mainView = options.main

  render: ->
    @$el.html @template
      shouldShow:
        customerButton: @_showCustomerButton()
        excludeCase: @_showExcludeCase()
        escalateCase: @_showEscalateCase()
        moderationComment: @_showModerationComment()
      account_settings: @model.account_settings
      users_of_customer: @model.users_of_customer
      users_groups_of_customer: @model.users_groups_of_customer
      new_case_note_placeholder: @model.new_case_note_placeholder
      hasContext: @model.hasContext()
      hasRelated: @model.hasRelated()
      moderationCommentPreview: @_moderationCommentPreview()
    @_renderNotes()
    @_renderModerationComment()
    this

  _renderNotes: ->
    @notes = new Monitoring.Views.SocialContentNotesView
      contentId: @model.id,
      el: @noteTemplate
    @notesCount = @$el.find('#notes-count')[0]
    @listenTo(@notes, 'decrementCounter', @decrementNotesCounter)
    @listenTo(@notes, 'notes:created:success', @incrementNotesCounter)
    @_renderNotesCounter()

  _renderNotesCounter: ->
    return unless @model.isReviewMode() or @mainView.isExploreMode() or @_isSurveysDashboard()
    $.ajax
      type: 'GET'
      url: "/monitoring/dashboard/notes/count?content_id=#{@model.id}"
      success: (response) => @$el.find('#notes-count').html(response.count)

  _isSurveysDashboard: ->
    $('body').hasClass 'surveys-dashboard'

  showNotes: =>
    @notes.show()

  incrementNotesCounter: ->
    number = @notesCount.innerHTML
    number++
    @notesCount.innerHTML = number

  decrementNotesCounter: ->
    number = @notesCount.innerHTML
    number-- if number != '0'
    @notesCount.innerHTML = number

  _showCustomerButton: ->
    @_newCasesFromMonitoring() and @_contentIsAllowed() and @model.topicAllowsCustomer()

  _newCasesFromMonitoring: ->
    Keepcon.currentAccount.monitoringSettings.configure_new_cases_from_monitoring

  _contentIsAllowed: ->
    (@_typeIsAllowed() or @_groupTypeIsAllowed()) and (not @_subTypeIsForbidden()) and (not @_contentIsListeningOnly()) and (not (@_isInstagramMention() and @_isGroupedByThread('instagram')))

  _typeIsAllowed: ->
    Keepcon.applicationSettings.customer.allowed_types.indexOf(@model.type()) != -1

  _groupTypeIsAllowed: ->
    Keepcon.applicationSettings.customer.allowed_group_types.indexOf(@model.groupType()) != -1

  _subTypeIsForbidden: ->
    Keepcon.applicationSettings.customer.forbidden_sub_types.indexOf(@model.subType()) != -1

  _contentIsListeningOnly: ->
    @model.isListeningOnly()

  _isInstagramMention:->
    @_isInstagram() and @model.isMention()

  _isInstagram: ->
    @model.type() == 'instagramMedia' or @model.type() == 'instagramComment'

  _isGroupedByThread: (type) =>
    not @_isGroupedByUser(type)

  _isGroupedByUser: (type) =>
    Keepcon.applicationSettings.customer.types_grouped_by_user.indexOf(type) != -1

  _shouldShowEscalateOnModelStatus: ->
    @model.get('review_status').toUpperCase() == 'NOT_REVIEWED'

  _shouldShowExcludeOnModelStatus: ->
    @model.get('review_status').toUpperCase() == 'ESCALATED'

  _showExcludeCase: ->
    @_isReviewMode() and @_thisContentPendingReview() and @_shouldShowExcludeOnModelStatus()

  _showEscalateCase: ->
    @_isReviewMode() and @_thisContentNotReviewed() and @_shouldShowEscalateOnModelStatus()

  _showModerationComment: ->
    @model.get('moderation_comment')

  _moderationCommentPreview: ->
    return unless @_showModerationComment()
    comment = @model.get 'moderation_comment'
    if comment.length > 100 then "#{comment.slice(0, 97)}..." else comment

  _isReviewMode: ->
    @model.get('review_mode')

  _thisContentPendingReview: ->
    @model.get('review_status') in ['NOT_REVIEWED', 'ESCALATED']

  _thisContentNotReviewed: ->
    @model.get('review_status') == 'NOT_REVIEWED'

  _thisContentModerated: ->
    not @_thisContentNotReviewed()

  _renderModerationComment: ->
    @$el.find('.moderation-comment').tooltip
      selector: ''
      placement: 'left'

  _showModerationCommentAlert: =>
    swal
      title: 'Moderation comment'
      text: @model.get('moderation_comment')

  _escalateCase:(event) ->
    sc_action_div= $(event.currentTarget.parentElement)
    @_confirmEscalateCase(sc_action_div)
    $('.sweet-alert').find('textarea.moderation_comment').focus()

  _deEscalateCase:(event) ->
    $(event.currentTarget.parentElement).removeClass('active')
    @model.set('moderation_comment', null)
    @trigger 'socialContent:deEscalateCase'

  _confirmEscalateCase:(sc_action_div) =>
    swal
      title: I18n.t('monitoring.dashboard.social_content.actions.escalate_case.s_title')
      text: @_confirmEscalateCaseText()
      html: true
      closeOnConfirm: false
      showCancelButton: true
      allowOutsideClick: true
      animation: "slide-from-top"
      (accepted) => @_onSubmitEscalation(accepted,sc_action_div)

  _confirmEscalateCaseText: ->
    label = I18n.t 'monitoring.dashboard.social_content.actions.escalate_case.s_text.label'
    textareaPlaceholder = I18n.t 'monitoring.dashboard.social_content.actions.escalate_case.s_text.placeholder'
    noInputError = I18n.t 'monitoring.dashboard.social_content.actions.escalate_case.s_text.message'
    "<div>#{label}:</div>
     <textarea class='moderation_comment' placeholder='#{textareaPlaceholder}' rows='5' cols='100'></textarea>
     <div style='display:none' class='sa-error-container no-input-error show'><div class='icon'>!</div><p>#{noInputError}</p></div>"

  _onSubmitEscalation: (accepted,sc_action_div) ->
    return @_cancelEscalation() unless accepted
    inputValue = $('.sweet-alert').find('.moderation_comment').val()
    return @_showModerationCommentError() unless inputValue
    sc_action_div.addClass('active')
    @model.set('moderation_comment', inputValue)
    @trigger 'socialContent:escalateCase'
    @_manuallyCloseSwal()

  _cancelEscalation: ->
    @model.set('moderation_comment', null)

  _showModerationCommentError: ->
    $('.no-input-error').show()
    false

  _manuallyCloseSwal: ->
    # Using this hack instead of closeOnConfirm option, to prevent swal from auto-closing when we need to show errors
    swal(title: '', timer: 1)

  _excludeCase:(event) ->
    sc_action_div= $(event.currentTarget.parentElement)
    sc_action_div.addClass('active')
    @trigger 'socialContent:excludeCase'

  _includeCase:(event) ->
    sc_action_div= $(event.currentTarget.parentElement)
    sc_action_div.removeClass('active')
    @trigger 'socialContent:includeCase'
